import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import CustomerItem from "./CustomerItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import PaginatorButton from "../../components/PaginatorButton";
import {fromJS} from "immutable";
import {graphql} from "react-apollo";
import {LIST_CUSTOMERS_WITH_FILTERS, ON_NEW_CUSTOMER} from "../../queries/customers";
import update from "immutability-helper";

class CustomersList extends Component {

  UNSAFE_componentWillMount() {
    this.props.subscribeToNewCustomers(this.props, {}); 
  }

  render() {
    let {loading, error, customers} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = fromJS([
      {id: "id", title: "Id"},
      {id: "name", title: "Name"},
      {id: "email", title: "Email"},
      {id: "subsActive", title: "Active"},
      {id: "subsPaused", title: "Paused"},
      {id: "subsCancelled", title: "Cancelled"},
      {id: "auth", title: "Auth"},
      {id: "code", title: "Ref. Code"}
    ])
    let customersData = fromJS(customers);
    return (
      <div>
        <Table 
          data={customersData.get("entries")} 
          renderer={CustomerItem} 
          mode="table"
          tableHeader={tableHeader}
          onItemClick={this.handleItemClick.bind(this)}
          extraClassName="accounts-customer-list"
          itemKey="customerId"
          showCount={true}
          selected={this.props.selectedCustomerId}
          />
      <PaginatorButton 
          metadata={customersData.get("metadata")} 
          onNext={this.handleNext.bind(this)}
          />
      </div>
    )
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          customers: {
            __typename: prev.customers.__typename,
            metadata: fetchMoreResult.customers.metadata,
            entries: [...prev.customers.entries, ...fetchMoreResult.customers.entries]
          }
        }
      }
    })
  }


  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("customerId");
    if (field === "id") {
      e.stopPropagation();
      this.props.onCustomerIdClick(id);
      return;
    }
    this.props.onSelectionChange(id);
  }  
}

const mapDispatchToProps = dispatch => ({
  subscribeToNewCustomers: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_NEW_CUSTOMER,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return update(prev, {
          customers: {
            entries: {
              $unshift: [subscriptionData.data.newCustomer]
            }
          }
        })
      }
    })
  }
})

const withSubscription = connect(mapDispatchToProps, mapDispatchToProps);

const withQuery = graphql(LIST_CUSTOMERS_WITH_FILTERS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        subscription: props.subscriptionFilter,
        marketing: props.marketingFilter,
        showDeleted: props.showDeleted,
        name: props.nameSearch,
        email: props.emailSearch,
        phone: props.phoneSearch,
        referralCode: props.referralCodeSearch,
        type: props.customerTypeFilter,
      }
    }
  })
})

export default withQuery(withSubscription(CustomersList));